/**
 * 휴지통을 서버가 아는가 — 화면 사이에 공유하는 한 칸 (2026-09-17).
 *
 * ## 왜 모듈인가
 *
 * 이 신호는 **목록 화면이 알아내고(휴지통 호출이 404/405 면 «모른다»), 셸 좌측 메뉴가 쓴다**.
 * 둘은 부모-자식이 아니라 `<Outlet/>` 을 사이에 둔 형제 관계라 props 로 내려줄 수가 없다.
 * 전역 상태를 새로 들일 만한 무게가 아니어서 구독 가능한 한 칸으로 둔다.
 *
 * ★ 기본값 `true` 가 곧 종전 동작이다 — 아무도 「모른다」고 말하지 않으면 휴지통은 그대로 보인다.
 * ★ 한 번 «모른다»로 내려가면 되돌리지 않는다. 서버 판이 바뀌면 새로고침이 정상 경로다.
 */

let supported = true;
const listeners = new Set<() => void>();

export function markBoardTrashUnsupported(): void {
  if (!supported) return;
  supported = false;
  listeners.forEach((fn) => fn());
}

export function getBoardTrashSupported(): boolean {
  return supported;
}

export function subscribeBoardTrashSupport(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
